import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { NgClass } from "@angular/common";

@Component({
  selector: "app-sport-page",
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, TranslateModule, NgClass],
  templateUrl: "./sport-page.component.html",
  styleUrl: "./sport-page.component.scss",
})
export class SportPageComponent implements OnInit {
  route = inject(ActivatedRoute);
  currentSport = "";

  tabs = [
    { label: "In-Play", path: "in-play" },
    { label: "Popular", path: "popular" },
    { label: "Upcoming", path: "upcoming" },
    { label: "Competition", path: "competition" },
  ];

  get filteredTabs() {
    if (["horse", "greyhound"].includes(this.currentSport)) {
      return this.tabs.filter((tab) => ["in-play", "upcoming"].includes(tab.path));
    }
    return this.tabs;
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.currentSport = params["sport"];
    });
  }
}
